import type { PricingAddon } from "./pricing.types";

/** Quantity-based subscription options shown separately from independent modules. */
export const METERED_FEATURE_SLUGS = [
  "extra-user",
  "extra-storage-location",
  "extra-storage-space",
  "extra-environment",
] as const;

const METERED_FEATURE_SET = new Set<string>(METERED_FEATURE_SLUGS);

export function isMeteredFeature(addon: Pick<PricingAddon, "slug">): boolean {
  return METERED_FEATURE_SET.has(addon.slug);
}

export function partitionPricingAddons(addons: PricingAddon[]) {
  return {
    meteredFeatures: addons.filter(isMeteredFeature),
    moduleAddons: addons.filter((addon) => !isMeteredFeature(addon)),
  };
}